import { render, staticRenderFns } from "./Endpoint.vue?vue&type=template&id=b43b870c&"
import script from "./Endpoint.vue?vue&type=script&lang=js&"
export * from "./Endpoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports